import type { DictsysInflectionSchemeContent } from "@/types/article-formats/dictsys";

export function makeInflectionCell(
  inflection: string,
  prefix = "",
  suffix = ""
): DictsysInflectionSchemeContent[] {
  return [
    {
      index: "",
      person: "",
      inflexion: inflection,
      prefix: prefix,
      suffix: suffix
    }
  ];
}
